<template>
  <transition name="fade" v-if="seen">
    <div class="popup">
      <div class="overlay"></div>
      <div class="popup-box">
        <img class="popup-close" @click="closed" src="https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/icon_close.png" />
        <div class="popup-title" v-text="title"></div>
        <div class="popup-content"><slot name="content"></slot></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { EVENT } from '@/constants/event'

export default {
  name: 'GSPopup',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      seen: true
    }
  },
  methods: {
    closed () {
      this.seen = false
      this.$emit(EVENT.CLOSED)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';
@import '../assets/scss/fade-transition';

.popup {
  top: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;

  .overlay {
    width: 100%;
    height: 100%;
    top: 0;
    background: #000000;
    opacity: 0.45;
  }

  .popup-box {
    position: fixed;
    width: 90%;
    top: 7%;
    bottom: 15%;
    left: 50%;
    transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    color: #88A7BA;
    background: #141E24;
    border: 1px solid #2E4A59;
    border-radius: $radius-size;
    padding: $base-size * 45;
    text-align: center;

    .popup-close {
      position: absolute;
      top: $base-size * 28;
      right: $base-size * 28;
      width: $base-size * 30;
    }

    .popup-title {
      position: absolute;
      font-size: $font-size-l;
      left: 50%;
      top: $base-size * 30;
      transform: translate(-50%, 0);
      -ms-transform: translate(-50%, 0);
    }

    .popup-content {
      position: absolute;
      top: $base-size * 100;
      right: 0;
      bottom: 0;
      margin: $base-size * 5 $base-size * 25 $base-size * 25;
      overflow: scroll;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSPopup.vue